import React, { Component } from 'react';
import { GenericEditPanel, GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class EsConfidencial extends Component {
    constructor(props) {
        super(props);

        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
        this.changeCheck = this.changeCheck.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} event
     */
    changeCheck(event) {
        this.props.changeCheck(0, this.props.codigoNovedad, event.target.value);
    }
    /**
     * 
     */
    render() {
        let props = this.props;
        let me = this;

        //////////Novedad en Es Confidencial////////////////
        let seEstaEditando = props.data.seEstaEditando;
        let check = undefined;
        let novedadEsConfidencial = undefined;
        let descripcionEsConfidencial = "Es Confidencial";
        if (props.data.novedadesEmpresaDatos != undefined) {
            novedadEsConfidencial = props.data.novedadesEmpresaDatos.find(x => x.NovedadCampoCodigo == this.props.codigoNovedad);
            if (novedadEsConfidencial != undefined) {
                novedadEsConfidencial.ValorAnterior = novedadEsConfidencial.ValorAnterior == "NO" ? "0" : novedadEsConfidencial.ValorAnterior == "SI" ? "1" : novedadEsConfidencial.ValorAnterior
                let esNovedadEditadaEsConfidencial = props.data.esNovedadEditada.find(x => x.campoCodigo == this.props.codigoNovedad).editado;
                if (esNovedadEditadaEsConfidencial) {
                    check = props.data.empresaDatos.EsConfidencial != undefined ? props.data.empresaDatos.EsConfidencial : false
                    novedadEsConfidencial.ValorAnterior = novedadEsConfidencial.ValorAnterior == "0" ? "NO" : novedadEsConfidencial.ValorAnterior == "1" ? "SI" : "NO"
                    descripcionEsConfidencial = novedadEsConfidencial.ValorNovedad == "0" ? "NO " + descripcionEsConfidencial : novedadEsConfidencial.ValorNovedad == "1" ? "√ " + descripcionEsConfidencial : "NO " + descripcionEsConfidencial
                }
                else {
                    check = novedadEsConfidencial.ValorNovedad == "0" ? false : novedadEsConfidencial.ValorNovedad == "1" ? true : false
                    novedadEsConfidencial.ValorAnterior = novedadEsConfidencial.ValorAnterior == "0" ? "NO" : novedadEsConfidencial.ValorAnterior == "1" ? "SI" : "NO"
                    descripcionEsConfidencial = novedadEsConfidencial.ValorNovedad == "0" ? "NO " + descripcionEsConfidencial : novedadEsConfidencial.ValorNovedad == "1" ? "√ " + descripcionEsConfidencial : "NO " + descripcionEsConfidencial
                }

            } else {
                check = props.data.empresaDatos.EsConfidencial != undefined ? props.data.empresaDatos.EsConfidencial : false
                descripcionEsConfidencial = check == false ? "NO " + descripcionEsConfidencial : "√ " + descripcionEsConfidencial
            }
        } else {
            check = props.data.empresaDatos.EsConfidencial != undefined ? props.data.empresaDatos.EsConfidencial : false
            descripcionEsConfidencial = check == false ? "NO " + descripcionEsConfidencial : "√ " + descripcionEsConfidencial
        }
        ///////////////////////////////////////////////////

        let componentechkEsConfidencial = (
            <div>
                <div className="col-xs-12">
                    <ul className="no-bullets no-padding no-margin">
                        <li className="inlineListItem2 lg-margin">
                            <div className="default-checkbox">
                                <input id="chkEsConfidencial" name="chkEsConfidencial" type="checkbox" onChange={this.changeCheck} checked={check} value={check} />
                                <label className="label-primary" htmlFor="chkEsConfidencial"></label>
                            </div>
                        </li>
                        <li className="inlineListItem2">
                            <label className="label-primary" htmlFor="chkEsConfidencial">Es Confidencial</label>
                        </li>
                    </ul>
                </div>
            </div>
        );
        return (
            <GenericEditPanel
                componente={componentechkEsConfidencial}
                error={false}
                permisoUsuario={props.data.funcionesDelUsuario}
                muestraDescripcion={false}
                novedad={novedadEsConfidencial}
                seEstaEditando={seEstaEditando}
                textPanel={descripcionEsConfidencial || "Sin especificar"}
                title="Confidencial"
                value={check}

                aceptChanges={(value) => this.props.guardarNovedad(value)}
                confirmarNovedad={() => this.actualizarNovedadEstado(novedadEsConfidencial, 2, props.data.empresaDatos.Id)}
                changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                denegarNovedad={() => this.actualizarNovedadEstado(novedadEsConfidencial, 3, props.data.empresaDatos.Id)}
                mostrarModificaciones={this.props.mostrarModal}
                revert={this.props.cancelar}
            />
        );
    }
}

export default EsConfidencial;